import { axiosInstance } from '../Api';

export default class Notifications {
  endPoint = 'Notifications';

  async getNotifications() {
    try {
      const r = await axiosInstance.get(`/${this.endPoint}/GetNotifications`);
      return r.data;
    } catch (error) {
      return {};
    }
  }
}
